import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import Popup from '../../../../components/Popup';
import UxHelpers from '../../../../helpers/ux-helpers';
import Dialog from '../../index';

const AccountUnsubscribeConfirmDialog = props => {
  const { show, proceed, dismiss } = props;

  const proceedHandler = (isRecommended) => {
    proceed(isRecommended);
    UxHelpers.overflowLock('unlock');
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={() => { proceedHandler(true) }}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Pause job & activity notifications (recommended)"
      />
      <BasicButton
        controlFunc={() => { proceedHandler(false) }}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Unsubscribe from all"
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <div style={{ textAlign: 'center' }}>
        Most users who are not currently recruiting prefer to pause notifications, they will resume in six months.
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{ proceed, dismiss }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(AccountUnsubscribeConfirmDialog));
